import { useContextSelector } from 'use-context-selector'

import { BackdropsContext } from './context'

export const useBackdropsContext = () => {
  const isCombinedItemsVisible = useContextSelector(BackdropsContext, state => state.isCombinedItemsVisible)
  const setIsCombinedItemsVisible = useContextSelector(BackdropsContext, state => state.setIsCombinedItemsVisible)
  const handleCombinedItemsState = useContextSelector(BackdropsContext, state => state.handleCombinedItemsState)
  const isCombineVisible = useContextSelector(BackdropsContext, state => state.isCombineVisible)
  const setIsCombineVisible = useContextSelector(BackdropsContext, state => state.setIsCombineVisible)
  const isAlertSizing = useContextSelector(BackdropsContext, state => state.isAlertSizing)
  const setShowAlertSizing = useContextSelector(BackdropsContext, state => state.setShowAlertSizing)
  const isSettingsVisible = useContextSelector(BackdropsContext, state => state.isSettingsVisible)
  const setIsSettingsVisible = useContextSelector(BackdropsContext, state => state.setIsSettingsVisible)
  const isAlertMeasurements = useContextSelector(BackdropsContext, state => state.isAlertMeasurements)
  const setIsAlertMeasurements = useContextSelector(BackdropsContext, state => state.setIsAlertMeasurements)
  const handleMeasurementsAlertOpen = useContextSelector(BackdropsContext, state => state.handleMeasurementsAlertOpen)
  const isOnboardingScreenVisible = useContextSelector(BackdropsContext, state => state.isOnboardingScreenVisible)
  const setIsOnboardingScreenVisible = useContextSelector(BackdropsContext, state => state.setIsOnboardingScreenVisible)
  const isOnboardingActiveScreenVisible = useContextSelector(
    BackdropsContext,
    state => state.isOnboardingActiveScreenVisible,
  )
  const setIsOnboardingActiveScreenVisible = useContextSelector(
    BackdropsContext,
    state => state.setIsOnboardingActiveScreenVisible,
  )
  const onOpenNewsletter = useContextSelector(BackdropsContext, state => state.onOpenNewsletter)
  const isSendMeasurementsBackdropOpen = useContextSelector(
    BackdropsContext,
    state => state.isSendMeasurementsBackdropOpen,
  )
  const setIsSendMeasurementsBackdropOpen = useContextSelector(
    BackdropsContext,
    state => state.setIsSendMeasurementsBackdropOpen,
  )

  /* Unavailable to wear backdrop */
  const isUnavailableToWearBackdropVisible = useContextSelector(
    BackdropsContext,
    state => state.isUnavailableToWearBackdropVisible,
  )
  const setIsUnavailableToWearBackdropVisible = useContextSelector(
    BackdropsContext,
    state => state.setIsUnavailableToWearBackdropVisible,
  )

  return {
    isCombinedItemsVisible,
    setIsCombinedItemsVisible,
    handleCombinedItemsState,
    isCombineVisible,
    setIsCombineVisible,
    isAlertSizing,
    setShowAlertSizing,
    isSettingsVisible,
    setIsSettingsVisible,
    isAlertMeasurements,
    setIsAlertMeasurements,
    handleMeasurementsAlertOpen,
    isOnboardingScreenVisible,
    setIsOnboardingScreenVisible,
    isOnboardingActiveScreenVisible,
    setIsOnboardingActiveScreenVisible,
    onOpenNewsletter,
    isSendMeasurementsBackdropOpen,
    setIsSendMeasurementsBackdropOpen,
    isUnavailableToWearBackdropVisible,
    setIsUnavailableToWearBackdropVisible,
  }
}
